import api from '../api';
import { queryToString } from 'helpers/AppHelpers';

export const getAssembledBOMListApi = (query) =>
  api.get(`/AssembledItems?${queryToString(query)}`).then((res) => res.data);

export const getLocationsApi = (query) =>
  api.get(`/Locations/Shorted?${queryToString(query)}`).then((res) => res.data);

export const getLocationsWithSublocationsApi = (query) =>
  api.get(`/Locations/ShortedWithSublocations?${queryToString(query)}`).then((res) => res.data);

export const getStatusesApi = () => api.get('/AssembledLooseItemStatuses').then((res) => res.data);

export const getLooseItemConfigurationsApi = () =>
  api.get('/ShortedLooseItemConfigurations').then((res) => res.data);

export const getConfigurationDataApi = (query) =>
  api.get(`/AssembledLooseItems?${queryToString(query)}`).then((res) => res.data);

export const getSingleAssembleApi = (id) =>
  api.get(`/AssembledItem?id=${id}`).then((res) => res.data);

export const createAssembleApi = (params) =>
  api.post('/AssembledItem', params).then((res) => res.data);

export const updateAssembleApi = (params) =>
  api.put('/AssembledItem', params).then((res) => res.data);

export const deleteAssembleApi = (id) =>
  api.delete(`/AssembledItem?id=${id}`).then((res) => res.data);

export const getCsvResourceApi = (q) =>
  api.get(`/AssembledItems/Serialized?${queryToString(q)}`).then((res) => res.data);
